(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.factory('odometerFormat', function () {
        return function (count) {
            var format = '(,ddd)';
            var postfix = '';
            if (count > 10000000) {
                postfix = 'm';
                count = count / 1000000;
            } else if (count > 1000000) {
                postfix = 'm';
                count = count / 1000000;
                format = '(,ddd).d';
            } else if (count > 10000) {
                postfix = 'k';
                count = count / 1000;
                format = 'd';
            }
            return '#' + JSON.stringify({
                display: 'odometer',
                text: count,
                odometer: {
                    duration: 10000,
                    format: format
                },
                'class': 'vertical-align-middle'
            }) + '#' + JSON.stringify({
                'text': postfix,
                'class': 'vertical-align-middle'
            });
        };
    });
}());